import { FC, ReactElement } from 'react';

import classNames from 'classnames';
import { OptionProps } from 'react-select';

import { FormImageOption } from '../../../../../entities/@forms/Form/Form';

import './SelectOption.scss';

export const SelectOption: FC<OptionProps<FormImageOption, false>> = ({
    data,
    innerRef,
    innerProps,
    isFocused,
    isSelected,
}): ReactElement => {
    const selectOptionClassNames = classNames('select-option', {
        'select-option--with-image': data.image,
        'select-option--is-focused': isFocused,
        'select-option--is-selected': isSelected,
    });

    return (
        <div
            ref={innerRef}
            {...innerProps}
            className={selectOptionClassNames}
        >
            {data.image && (
                <div className="select-option__image-wrapper">
                    <img
                        src={data.image.src}
                        alt={data.image.alt}
                        className="select-option__image"
                    />
                </div>
            )}

            <span>{data.label}</span>
        </div>
    );
};
